<mat-card appearance="outlined">
    <form class="fix-editor">
        @let _decimal = decimal();
        @if (_decimal && _decimal > 0) {
            <mat-form-field class="ag-row fix-mat-form" [style.width]="width()">
                <input
                    matInput
                    type="text"
                    autocomplete="off"
                    [pattern]="PATTERNS.NUMERIC_DECIMAL"
                    [formControl]="numericFormControl()"
                    [focusSelectOn]="cellReady()"
                    [normalizeDecimalSeparator]="separatorInUse()"
                />
                @if (numericFormControl().hasError("max")) {
                    <mat-error>
                        {{ "ValidationErrorMax" | translate: { p0: max() } }}
                    </mat-error>
                }
                @if (numericFormControl().hasError("min")) {
                    <mat-error>
                        {{ "ValidationErrorMin" | translate: { p0: min() } }}
                    </mat-error>
                }
                @if (numericFormControl().hasError("required")) {
                    <mat-error>
                        {{ "se-ui-datagrid_required_value_constraint" | translate }}
                    </mat-error>
                }
            </mat-form-field>
        } @else {
            <mat-form-field class="ag-row fix-mat-form" [style.width]="width()">
                <input
                    matInput
                    type="text"
                    autocomplete="off"
                    [formControl]="numericFormControl()"
                    [focusSelectOn]="cellReady()"
                    [normalizeDecimalSeparator]="separatorInUse()"
                />
                @if (numericFormControl().hasError("max")) {
                    <mat-error>
                        {{ "ValidationErrorMax" | translate: { p0: max() } }}
                    </mat-error>
                }
                @if (numericFormControl().hasError("min")) {
                    <mat-error>
                        {{ "ValidationErrorMin" | translate: { p0: min() } }}
                    </mat-error>
                }
                @if (numericFormControl().hasError("required")) {
                    <mat-error>
                        {{ "se-ui-datagrid_required_value_constraint" | translate }}
                    </mat-error>
                }
            </mat-form-field>
        }
    </form>
</mat-card>
